/********************************************************************
 * Project: WDCK（2021）
 * Class: DefaultLayoutComponent
 * ----------------------------------------
 * <summary>
 * DefaultLayoutComponent
 * </summary>
 * <history>
 *      ThaiTV     2021/07/27      Create
 * </history>
 ********************************************************************/
import { Component, OnInit} from '@angular/core';
import { HostListener } from '@angular/core';
import { LanguageTranslateService } from 'src/app/services/lang-translate.service';
import { Utility } from 'src/app/shared/utility/utility';
@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
})

export class DefaultLayoutComponent implements OnInit {
  // Declare height and width variables
  scrHeight: any;
  strCurrLanguage = '';
  countLoad = true;
  // Constructor
  constructor(public util: Utility,
              private lgService: LanguageTranslateService, ) {
  }
  ngOnInit(): void{
    this.lgService.currLangSubject.subscribe(lg => {
      this.strCurrLanguage = lg;
      let lang = '';
      setTimeout(() => {
        lang = localStorage.language;
      }, 10);
      if (lang && this.countLoad){
        this.setLang(lang);
        this.countLoad = false;
      } else {
        this.setLang(lg);
      }
    });
    this.util.addPerfectScrollBar();
  }
  setLang(lang: string){
    if (lang === 'ja' || lang === 'jp') {
      $('body').removeClass('Vi');
      $('body').addClass('Jap');
    } else if (lang === 'vi'){
      $('body').removeClass('Jap');
      $('body').addClass('Vi');
    } else{
      $('body').removeClass('Jap');
      $('body').removeClass('Vi');
    }
  }
}
